import { Injectable } from '@angular/core'
import { Subject } from 'rxjs/Subject'

@Injectable()
export class ClientDetailServices {

    constructor() {
    }

    // Observable string sources
    private emitChangeSource = new Subject<any>()
    private emitChangeSourceParent = new Subject<any>()
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable()
    changeEmittedSource$ = this.emitChangeSourceParent.asObservable()

    // Service message commands
    emitChange(change: any) {
        this.emitChangeSource.next(change)
    }

    emitChangeParent(change: any) {
        this.emitChangeSourceParent.next(change)
    }


}



// WEBPACK FOOTER //
// ./src/app/services/ClientDetail.services.ts